function loadBrevoScript(callback) {
  var existingScript = document.getElementById('brevoNewsletterScriptTag');
  if (existingScript) {
    existingScript.remove();
  }
  
  var script = document.createElement('script');
  script.id = 'brevoNewsletterScriptTag';
  script.src = 'https://sibforms.com/forms/end-form/build/main.js';
  script.type = 'text/javascript';
  
  script.onload = function() {
    console.log('[Brevo] Script loaded and ready');
    if (callback) callback();
  };
  
  script.onerror = function() {
    console.error('[Brevo] Script failed to load');
    if (typeof showBrevoFallback === 'function') showBrevoFallback();
  };
  
  document.head.appendChild(script);
}

function brevoHasConsent() {
  var consentDiv = document.getElementById('brevoNewsletterConsent');
  if (!consentDiv) {
    console.warn('[Brevo] brevoNewsletterConsent div not found');
    return;
  }
  
  consentDiv.innerHTML = "";

  window.REQUIRED_CODE_ERROR_MESSAGE = 'Wählen Sie bitte einen Ländervorwahl aus.';
  window.LOCALE = 'de';
  window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "Die eingegebenen Informationen sind nicht gültig. Bitte überprüfen Sie das Feldformat und versuchen Sie es erneut.";
  window.REQUIRED_ERROR_MESSAGE = "Dieses Feld darf nicht leer sein. ";
  window.GENERIC_INVALID_MESSAGE = "Die eingegebenen Informationen sind nicht gültig. Bitte überprüfen Sie das Feldformat und versuchen Sie es erneut.";

  window.translation = {
    common: {
      selectedList: '{quantity} Liste ausgewählt',
      selectedLists: '{quantity} Listen ausgewählt'
    }
  };

  var AUTOHIDE = Boolean(0);

  if ("content" in document.createElement("template")) {
    const template = document.querySelector("#BrevoNewsLForm");

    if (template && template.content) {
      const FormDiv = document.querySelector("#brevoNewsletterConsent");
      const clone = template.content.cloneNode(true);
      FormDiv.appendChild(clone);
      
      // Warte auf reCAPTCHA
      console.log('[Brevo] Waiting for reCAPTCHA...');
      
      function initBrevoWithRecaptcha() {
        if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
          grecaptcha.ready(function() {
            console.log('[Brevo] reCAPTCHA is ready');
            loadBrevoScript(function() {
              console.log('[Brevo] Form initialized with reCAPTCHA');
            });
          });
        } else {
          console.warn('[Brevo] reCAPTCHA not found, retrying...');
          setTimeout(initBrevoWithRecaptcha, 500);
        }
      }
      
      // Starte Check
      initBrevoWithRecaptcha();
      
      // Fallback nach 10 Sekunden
      setTimeout(function() {
        if (!document.getElementById('brevoNewsletterScriptTag')) {
          console.warn('[Brevo] Timeout waiting for reCAPTCHA, loading anyway');
          loadBrevoScript(function() {
            console.log('[Brevo] Form initialized without reCAPTCHA');
          });
        }
      }, 10000);
      
    } else {
      console.warn('[Brevo] Template #BrevoNewsLForm not found, showing fallback');
      showBrevoFallback();
    }
  } else {
    showBrevoFallback();
  }
}

function showBrevoFallback() {
  var consentDiv = document.getElementById('brevoNewsletterConsent');
  if (consentDiv) {
    consentDiv.innerHTML = '<div style="text-align:center; padding: 20px 10px;"><h3 style="color:#009d3d;">Newsletter</h3><div style="padding: 5px 0;"><p>Sichern Sie sich jetzt Ihren Einkaufsgutschein im Wert von 10,- Euro und seien Sie immer aktuell informiert.***<br>Erhalten Sie auf unserer <a style="color: #3C4858;" href="https://boc24.de/pages/newsletter">Newsletterseite</a> mehr Informationen.</p><p style="font-size:16px; color:#3C4858;">Sie können den Newsletter jederzeit über einen Link in unserem Newsletter abbestellen.</p></div></div>';
  }
}

function brevoHasNOConsent() {
  document.cookie = "cbuid_meta= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
  
  var consentDiv = document.getElementById('brevoNewsletterConsent');
  if (consentDiv) {
    consentDiv.innerHTML = '<div style="text-align:center; padding: 20px 10px;"><h3 style="color:#3C4858;">Newsletter</h3><div style="padding: 5px 0;"><p>Sichern Sie sich jetzt Ihren Einkaufsgutschein im Wert von 10,- Euro und seien Sie immer aktuell informiert.***<br>Erhalten Sie auf unserer <a style="color: #3C4858; text-decoration: underline;" href="https://boc24.de/pages/newsletter">Newsletterseite</a> mehr Informationen.</p><p style="font-size:16px; color:#3C4858;">Sie können den Newsletter jederzeit über einen Link in unserem Newsletter abbestellen.</p></div></div>';
  }
}

function getConsentValue(e) {
  if (e.detail && e.detail.event == "consent_status") {
    if (e.detail['Brevo'] === true && e.detail['reCaptcha v3'] === true) {
      brevoHasConsent();
    } else {
      brevoHasNOConsent();
    }
  }
}
  
window.addEventListener("ucEvent", function(e) {
  getConsentValue(e);    
});

window.addEventListener('load', function() {
  var idBrevo = 'dQwK0_tGzCTAY1';
  var idReCaptcha = 'cfADcn3E3';
  
  try {
    var uc_settings = JSON.parse(localStorage.getItem('ucData'));
    
    if (typeof uc_settings === 'object' 
      && uc_settings !== null 
      && typeof uc_settings.consent === 'object'
      && typeof uc_settings.consent.services === 'object') {
      
      var services = uc_settings.consent.services;
      var hasBrevoConsent = services[idBrevo] && services[idBrevo].consent === true;
      var hasReCaptchaConsent = services[idReCaptcha] && services[idReCaptcha].consent === true;
      
      if (hasBrevoConsent && hasReCaptchaConsent) {
        brevoHasConsent();
      } else {
        brevoHasNOConsent();
      }
    } else {
      brevoHasNOConsent();
    }
  } catch (e) {
    console.error('[Brevo] Error reading consent:', e);
    brevoHasNOConsent();
  }
});
